// import store from "./store";

export default {
  install: (app) => {
    app.config.errorHandler = (err, vm, info) => {
      // eslint-disable-next-line
      if (process.env.NODE_ENV === "development") {
        console.group(">>>>>> 错误信息 >>>>>>");
        console.log(info);
        console.groupEnd();
        console.group(">>>>>> Vue 实例 >>>>>>");
        console.log(vm);
        console.groupEnd();
        console.group(">>>>>> Error >>>>>>");
        console.log(err);
        console.groupEnd();
      } else {
        console.log('uav error==>', err)
        console.log('uav vm==>', vm)
        console.log('uav info==>', info)
        if (vm && vm.$options) {
          console.error('[组件名称]', vm.$options.name)
          console.error('[组件路径]', vm.$options.__file)
        }
      }
    };
  },
};
